import { Injectable } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { ChatMachineEventEnum, ChatMachineStatesEnum, ChatMachineEvent, ChatAvailabilityStateEnum, ReportItemSLA, BrowserTypeEnumSLA, SourceIdEnumSLA, QueueAnswerEnumSLA } from './interfaces-livechat'
import { IMessage, IMessageFrom } from './interfaces'
import axios from "axios";
import Axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import { ErrorHandler } from "@angular/core";
import * as moment from 'moment';
import { Logger } from './chatbot-logger.service'
import { MessageBus } from './service-bus.service'
import { Observable, Subscriber, timer, interval, from, defer, of, Subscription } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import * as uuid from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class LivechatHttpClientService {
  private messageBus: MessageBus

  private token: string = null
  private serverUrl: string = "https://conectart-csu.daktela.com"
  //private serverUrl: string = "https://csu.daktela.com"
  private contextUrl: string = "/external/web/api/"


  private chatReport: []

  LV_CHAT_NOT_ACTIVE: string = "Chat již není aktivní"
  LV_OP_ENDED_BY_OP_CHAT_MSG: string = `Spojení bylo přerušeno`

  private axiosTimeout: number = 10000

  private fsmState: ChatMachineStatesEnum = ChatMachineStatesEnum.botLoaded

  //polling Pro new chat
  private maxlInitialPollTimeout: number = 1000 * 60 * 3 //3 minuty timeout na reakci operatora
  private pollInterval: number = 5000
  public newChatPollForOpResponse$: Observable<number>
  public newChatNoOpAvailableTimeout$: Observable<number>
  public newChatWaitForOperator$: Observable<number>
  private newChatWaitForOperatorSubscription: Subscription

  //Polling pro existing chat
  private maxlExistingPollTimeout: number = 1000 * 60 * 3600
  private pollExistingInterval: number = 2000
  public existingChatPollForOpResponse$: Observable<number>
  public existingChatNoOpAvailableTimeout$: Observable<number>
  public existingChatWaitForOperator$: Observable<number>
  existingChatWaitForOperatorSubscription: Subscription

  private version: string
  private axiosClient: AxiosInstance;
  private errorHandler: ErrorHandler;
  private txStartTimestamp: string
  private txEndTimestamp: string

  //Nepouziva se, mam axiosClienta
  private httpOptions = {
    headers: {
      // 'Content-Type': '',
      // 'Accept': 'application/json'
    }
  }

  private activeChatName: string
  private activeChatHash: string
  private chatMessageIds: object = {}
  private machineStateSub: Subscription

  /*
  https://conectart-csu.daktela.com/external/apihelp/v6/working-with/website-client
  The attribute "state" determines the current state of the website client (ONLINE / OFFLINE).
  */

  //SLA reporting
  private currentRecordSLA: ReportItemSLA = null
  private channelSLA: SourceIdEnumSLA
  private urlSLA: string
  private apikeySLA: string
  private slaCheckCounter: number = 0


  constructor(errorHandler: ErrorHandler, messageBus: MessageBus) {
    this.errorHandler = errorHandler;
    this.messageBus = messageBus

    // The ApiClient wraps calls to the underlying Axios client.
    this.axiosClient = axios.create({
      timeout: this.axiosTimeout,
      headers: {
        // "X-Initialized-At": Date.now().toString(),
        // 'Content-Type': 'application/json;charset=UTF-8',
        // 'Accept': 'application/json;charset=UTF-8'
      }
    });

    this.machineStateSub = this.messageBus.getMachineStateFromBus().subscribe(state => {
      Logger.info(`LV:HTTP:API got status update from bus: ${state}`)
      if (state) {
        //POzor: state = event, ktery ho zpusobil
        this.fsmState = state
        //Logika pro monitoring stavu a vyhodnocovani funkci chatbota
        //Prepnuti na LV v pripade nedostupnosti pri loginu
        if (state == ChatMachineStatesEnum.opDidNotStart || state == ChatMachineStatesEnum.waitingForOpWasEndedByUser || state == ChatMachineStatesEnum.opEnded) {

          Logger.info(`LV:HTTP:API Ending polling messages, chat ended/not started`)
          this.newChatWaitForOperatorSubscription.unsubscribe()


        } else if (state == ChatMachineStatesEnum.opActive) {

          Logger.info('------------------------------------------------------> LV on opActive: to start reading message from op WHO picked queue')

          this.readMessagesOnActiveChat()

        } else if (state == ChatMachineStatesEnum.opWaitingForOp1) {
          //update SLA: cas kdy zmacknul tlacitko chat s operatorem, (GDPR consenst)
          //   console.log("DEBUG ============================================================")
          this.udateReportForLV()
          this.uploadReportForLV()
          this.currentRecordSLA.sessionId = uuid.v4()
          this.currentRecordSLA.date = null
          this.currentRecordSLA.date = moment().format('DD.MM.YYYY')
          this.currentRecordSLA.time = null
          this.currentRecordSLA.time = moment().format('HH:mm:ss')

          this.slaCheckCounter = 0
        } else if (state == ChatMachineStatesEnum.waitingForGdprConsentWasEndedByUser) {
          this.slaCheckCounter = 0
        }
      } else {

      }
    })

    /*
      struktura config objektu
     {"url":"https://conectart-csu.daktela.com/external/web/api/settings.json?accessToken=8po2qror92o7n4q1r30n732o626081op",
     "method":"get",
     "headers":{
       "common":{"Accept":"application/json, text/plain"},"delete":{},"get":{},"head":{},
     "post":{"Content-Type":"application/x-www-form-urlencoded"},
     "put":{"Content-Type":"application/x-www-form-urlencoded"},
     "patch":{"Content-Type":"application/x-www-form-urlencoded"}
    },"transformRequest":[null],"transformResponse":[null],
      "timeout":3000,"xsrfCookieName":"XSRF-TOKEN","xsrfHeaderName":"X-XSRF-TOKEN","maxContentLength":-1,"maxBodyLength":-1}
     */

    /* jako testovani CORS Daktely
    this.axiosClient.interceptors.request.use(
      config => {
        Logger.info(`Axios headers BEFORE: ${JSON.stringify(config)}`)
        if (config.method == 'post'){

          config.headers.post = {}
          config.headers.put = {}
          config.headers.patch = {}
        }
        Logger.info(`Axios headers AFTER: ${JSON.stringify(config)}`)

        return config;
      },
      error => Promise.reject(error)
    );
*/

  }


  public initWithDataForSLA(channel: string, browser: BrowserTypeEnumSLA, url: string, apikey: string): void {
    if (channel == "portal") {
      this.channelSLA = SourceIdEnumSLA.web2
    } else {
      if (browser == BrowserTypeEnumSLA.mobile) {
        this.channelSLA = SourceIdEnumSLA.onlineMob
      } else {
        this.channelSLA = SourceIdEnumSLA.onlineWeb
      }
    }

    this.urlSLA = url
    this.apikeySLA = apikey

  }

  /**
   * Dactela zahadne vraci vsechno zabalene v () a jako STRING, musi se odstranit a pak se da udelat JSON.parse
   * @param data 
   */
  public checkAndTransformResponse(response: AxiosResponse<any>): any {
    try {
      if (response && response.status && (response.status == 200 || response.status == 201)) {
        if (response.data) {
          if (typeof response.data === 'object') {
            return response.data

          } else if (response.data.length > 0) {
            let dataStr = response.data
            if (dataStr && dataStr.length > 0) {
              let strTemp = dataStr.replace("(", "").replace(")", "")
              let data = JSON.parse(strTemp)
              if (data && typeof data === 'object') {
                return data
              } else {
                throw (`LV:ERR Invalid incoming data: ${dataStr}`)
              }
            } else {
              throw (`LV:ERR: NO incoming data found`)
            }
          } else {
            throw (`LV:ERR: Invalid data, missing data element in response`)
          }
        } else {
          throw (`LV:ERR: NO incoming data found`)
        }
      } else {
        throw (`LV:ERR: https status: ${response.status}`)
      }
    } catch (err) {
      Logger.error(`LV:ERR: ${JSON.stringify(err)}`)
      throw ('')
    }
  }

  /**
   * Inicializace z root komponenty, predani inicializiacniho apikey z externi konfigurace
   * @param token 
   */
  public async setOptionsAndCheckAvailabilityStatus(token: string, shouldUploadReportSLA: boolean): Promise<ChatAvailabilityStateEnum> {
    this.token = token

    Logger.info(`LV:Running with livechat access token: ${token}`)

    return await this.checkChatStatusReq(shouldUploadReportSLA)

    /*
    await this.readMessage(this.activeChatName, this.activeChatHash)
    //console.log("DEBUG2====================================")

    setTimeout(() => {
      //console.log("getMessage....1")
      this.readMessage(this.activeChatName, this.activeChatHash)


    }, 5000)

    setTimeout(() => {
      //console.log("getMessage....2")
      this.readMessage(this.activeChatName, this.activeChatHash)


    }, 10000)

    setTimeout(() => {
      //console.log("sendMsg....1")
      this.sendMessage(this.activeChatName, "od klienta 1")


    }, 20000)

    setTimeout(() => {
      //console.log("getMessage....3")
      this.readMessage(this.activeChatName, this.activeChatHash)


    }, 30000)

    setTimeout(() => {
      //console.log("sendMessage....2")
      this.sendMessage(this.activeChatName, "od klienta 2")


    }, 40000)
*/
  }

  /*
    HTTP/AXIOS VOLANI
    RxJS loose binding
    new chat vytvori observable interval pro navazujici read messages 
  */

  promiseDelay(ms) {
    return new Promise(resolve => {
      setTimeout(() => resolve('done'), ms);
    });
  }

  /**
   * vola se se opakovane pri kazdem 180 sec cyklu (ale pouze poprve se vola na server)
   * @param mode (pokud 0 tak se vola LV server s historii / pokud 1 tak se pouze obnovuje observable na cekani)
   * @param history 
   */

  updateLinksInHTML(html) {
    //console.log("-------------------------------------------- updateLinksInHTML")

    //kompletne odstrani link - to nechci
    //html = html.replace(/<a\b[^>]*>(.*?)<\/a>/i, "").replace(/<\/a>/i, "")
    html = html.replace(/<a\b[^>]*>/ig, "").replace(/<\/a>/ig, "")
    html = html.replace(/www./ig, "")
    return html;

  }

  public async createNewChat(mode: number, history?: IMessage[]) {
    try {

      // pokud 0 tak se vola LV server s inicialni history 
      console.log("DEBUG - new chat =======================================")
      if (mode == 0) {
        let messages = []
        this.txStartTimestamp = moment().toISOString()
        let url = `${this.serverUrl}${this.contextUrl}newWebchat.json?accessToken=${this.token}&_uuid=${uuid.v4()}`

        let firstAuthorIndex = history.findIndex((item) => {
          if (item.from.id === "author") {
            return true
          }
        })
        if (firstAuthorIndex > 0) {
          //nalezeno

          try {
            let firstQuestionEven: boolean = false
            if (history.length > firstAuthorIndex + 1) {

              //odfiltrovat formatovani fulltext: '<strong class="unitx-chatbot-msg-ft">{i}</strong>'
              //strong
              //url/mailto <a href=\"https://www.scitani.cz/kontaktnimisto\" target=\"_blank\">scitani.cz/kontaktnimisto</a>
              // <br/>

              for (let h of history) {
                h.message[0] = h.message[0].replace(/<br\/>/g, '')
                h.message[0] = h.message[0].replace(/<strong>/g, '')
                h.message[0] = h.message[0].replace(/<\/strong>/g, '')
                h.message[0] = h.message[0].replace(/<strong class="unitx-chatbot-msg-ft">/g, '')
                h.message[0] = this.updateLinksInHTML(h.message[0])
              }

              for (var i = (firstAuthorIndex + 1); i < history.length; i += 2) {
                //zacinam odpovedi na otazku

                messages.push({
                  "type": "PUBLIC",
                  "text": `Otázka: ${JSON.stringify(history[i - 1].message[0])}:`,
                  "direction": "IN"
                })

                messages.push({
                  "type": "PUBLIC",
                  "text": `Odpověď: ${JSON.stringify(history[i].message[0])}`,
                  "direction": "IN"
                })


              }
            }
          } catch (err) {
            Logger.error(`LV:parsing history failed with err:  ${JSON.stringify(err)}`)

          }

        } else {
          //nic nenalezeno
          messages = [
            {

              "type": "PUBLIC",
              "text": "Žádný předchozí dotaz uživatele",
              "direction": "IN"
            }]
        }
        //   console.log("DEGUG = ===============================")
        let payload = {
          messages: messages,
          inputs: {
            title: this.currentRecordSLA ? this.currentRecordSLA.sessionId : uuid.v4()
          }

        }
        Logger.info(`LV:Running new chat req. with: ${url}, payload: ${JSON.stringify(payload)}`)

        // CORS pokus bez headers
        // let res = await this.axiosClient.post(url,payload,{headers: {}})

        let res = await this.axiosClient.post(url, payload)
        //throw("test")


        this.txEndTimestamp = moment().toISOString()
        ////console.log("DEBUG====================================")

        let data = this.checkAndTransformResponse(res)

        //Zasadni hodnoty pomoci, kterych se dela POLLING na server
        this.activeChatName = data.result.name
        this.activeChatHash = data.result.hash
        Logger.info("-".repeat(50))
        Logger.info(JSON.stringify(data.result))
        Logger.info("-".repeat(50))
        Logger.info(`LV:HTTP:API Chat started with name: ${data.result.name} and hash: ${data.result.hash}`)
        Logger.info("-".repeat(50))



      }

      //Vzdy se Inicializuje observable pro service->parent jak pro prvni 180 sec kolo tak i pro druhe po zmacknuti tlacitka "stale chci" uzivatelem

      if (this.newChatWaitForOperatorSubscription) {
        this.newChatWaitForOperatorSubscription.unsubscribe()
      }
      //Spusti observable simple interval 
      this.newChatPollForOpResponse$ = timer(0, this.pollInterval)

      //Unsubsribe Zrusit po definovane dobe -> client message
      this.newChatNoOpAvailableTimeout$ = timer(this.maxlInitialPollTimeout)
      this.newChatWaitForOperator$ = this.newChatPollForOpResponse$.pipe(takeUntil(this.newChatNoOpAvailableTimeout$))

      this.newChatWaitForOperatorSubscription = this.newChatWaitForOperator$.subscribe(
        (t) => {
          this.readMessagesOnNewChat(t)
        },
        (err) => {
          Logger.info(`LV:HTTP:API newChatWaitForOperator error: ${JSON.stringify(err)}`)
          this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_DID_NOT_START)
        },
        () => {
          Logger.info("LV:HTTP:API newChatWaitForOperator timeout, NO OP picked up new chat request")
          this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_DID_NOT_START)

        }

      )

      /* 
     this.newChatWaitForOperator$ =interval(this.pollInterval).pipe(
     switchMap(()=> defer(async function() {
      
       return await this.readMessageReq()
       
     })
     )
     )
     */



    } catch (err) {
      Logger.error(`LV:ERR createNewChat: ${JSON.stringify(err)}`)
      this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_UNEXPECTED_ERR)

      // this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_DID_NOT_START)
      // od 28.2.21

      /*
        loguji v metode,
        TBD: how to handle
      */

    }
  }

  /*
 RxJS funkce 
 */

  /**
   * array of objects:
      attachments: []
      direction: ""
      name: "messages_5fe83d67a6045704342168"
      text: "Čekejte na spojení s operátorem."
      time_created: "2020-12-27T07:53:11+00:00"
      type: "PUBLIC"
      user: null
   * @param t 
   */

  /**
   * PRO POLLING PRI PRVNIM CEKANI NA OPERATORA
   * @param t 
   */
  public async readMessagesOnNewChat(t) {
    try {
      Logger.info(`LV:checking operator response in ${t * this.pollInterval / 1000} sec after new chat request`)
      //  //console.log(`LV:checking operator response in ${t * this.pollInterval / 1000} sec after new chat request`)

      let opResponse = await this.readMessageReq()
      if (opResponse && opResponse.messages) {
        let messages = opResponse.messages

        if (messages && Array.isArray(messages) && messages.length > 0) {

          let msgAr1: any[] = messages.filter((item) => {
            if (item.text && item.text.length > 0) {
              if (!item.direction || (item.direction && item.direction === "OUT")) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          })

          let msgAr2 = msgAr1.filter((item) => {
            if (this.chatMessageIds.hasOwnProperty(item.name) && this.chatMessageIds[item.name] == item.text) {
              //     //console.log(`-----------------------------------------> MessageId: ${item.name} already processed. Skipping...`)
              return false
            } else {
              //     //console.log(`------------------------------------------> MessageId: ${item.name} NOT yet processed. Displaying new OP answer: ${item.text}`)
              this.chatMessageIds[item.name] = item.text
              return true
            }

          })

          let msgAr3: IMessage[] = msgAr2.map((item) => {


            return {
              from: {
                avatar: "",
                id: "op",
                name: "",
                photo: ""
              },
              message: [item.text],
              message2: [],
              timeStamp: moment(item.time_created).toISOString(),
              generic: {},
              parsedMessage: "",
              parsedButtons: [],
              shouldDisplayButtons: false,
              index: -1,
              loading: false
            }

          })

          for (let output of msgAr3) {
            //check for pripojil/pripojila and reformat



            //Publish answer from op to bus and indirectly to parent/messages
            this.messageBus.publishMessageToBus(output)
            Logger.info(`LV:HTTP:API operator response published on the bus: ${JSON.stringify(output)}`)
          }

          //Zpracovani ANSWERED -> pripadne preruseni long polling cyklu a zmena stavu


          if (opResponse.answered && opResponse.users.length > 0) {
            this.newChatWaitForOperatorSubscription.unsubscribe()
            this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_DID_START)
          }
        }

      }
    } catch (err) {
      Logger.error(`LV:ERR readMessagesOnNewChat: ${JSON.stringify(err)}`)

      this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_DID_NOT_START)
    }
  }



  public async readMessagesOnActiveChat() {
    try {
      if (this.fsmState == ChatMachineStatesEnum.opActive) {
        //Inicializuje observable pro service->parent

        //Spusti observable simple interval 
        this.existingChatPollForOpResponse$ = interval(this.pollExistingInterval)

        //Unsubsribe Zrusit po definovane dobe -> client message
        this.existingChatNoOpAvailableTimeout$ = timer(this.maxlExistingPollTimeout)
        this.existingChatWaitForOperator$ = this.existingChatPollForOpResponse$.pipe(takeUntil(this.existingChatNoOpAvailableTimeout$))

        this.existingChatWaitForOperatorSubscription = this.existingChatWaitForOperator$.subscribe(
          (t) => {
            //  //console.log('DEBUG==================================================================== readMessagesOnActiveChat')
            if (this.fsmState === ChatMachineStatesEnum.opFeedback || this.fsmState === ChatMachineStatesEnum.opEnded || this.fsmState === ChatMachineStatesEnum.waitingForOpWasEndedByUser) {
              //Pro tyto stavy nezobrazovat pripadne zpravy od OP
            } else {
              //Pro vsechny ostatni stavy zobrazovat zpravy
              this.readMessagesOnActiveChat2(t)
            }
          },
          (err) => {
            Logger.info(`LV:HTTP:API existingChatWaitForOperator error: ${JSON.stringify(err)}`)

            this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_UNEXPECTED_ERR)
          },
          () => {
            Logger.info("LV:HTTP:API existingChatWaitForOperator timeout, NO OP picked up new chat request")
            this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_UNEXPECTED_ERR)

          }

        )
      }

    } catch (err) {
      Logger.error(`LV:ERR readMessagesOnActiveChat: ${JSON.stringify(err)}`)
      this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_UNEXPECTED_ERR)
      /*
        loguji v metode,
        TBD: how to handle
      */

    }
  }

  /**
   * PRO polling pri JIZ otevrenem chatu
   * @param t 
   */
  public async readMessagesOnActiveChat2(t) {
    try {
      Logger.info(`LV:checking operator response in ${t * this.pollInterval / 1000} sec after new chat request`)
      //    //console.log(`LV:checking operator response in ${t * this.pollInterval / 1000} sec after new chat request`)
      let opResponse = await this.readMessageReq()
      if (opResponse && opResponse.messages) {
        let messages = opResponse.messages

        if (messages && Array.isArray(messages) && messages.length > 0) {




          //Nalezeni hlasky chat ukoncen ->  preruseni long polling cyklu a zmena stavu
          /* 
          jinak polling probiha az do ukonceni chatu?
          ANSWERED nelze pouzit: zustava stlae TRUE a rovnez USERS -> z toho nelze usoudit na konec od OP -> pouze presny text hlasky
          */

          let msgAr4: any[] = messages.filter((item) => {
            if (item.text && item.text.length > 0) {
              if (item.text === this.LV_OP_ENDED_BY_OP_CHAT_MSG) {
                return true
              } else {
                return false
              }
            } else {
              return false
            }
          })

          if (msgAr4.length > 0) {
            //hlaska Spojeni bylo ukonceno JE ale nahrazeno vlastni hlaskou
            this.existingChatWaitForOperatorSubscription.unsubscribe()
            this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_FEEDBACK)

          } else {

            let msgAr1: any[] = messages.filter((item) => {
              if (item.text && item.text.length > 0) {
                if (!item.direction || (item.direction && item.direction === "OUT")) {
                  return true
                } else {
                  return false
                }
              } else {
                return false
              }
            })

            let msgAr2 = msgAr1.filter((item) => {
              if (this.chatMessageIds.hasOwnProperty(item.name) && this.chatMessageIds[item.name] == item.text) {
                //   //console.log(`-----------------------------------------> MessageId: ${item.name} already processed. Skipping...`)
                return false
              } else {
                //   //console.log(`------------------------------------------> MessageId: ${item.name} NOT yet processed. Displaying new OP answer: ${item.text}`)
                this.chatMessageIds[item.name] = item.text
                return true
              }

            })


            let msgAr3: IMessage[] = msgAr2.map((item) => {


              return {
                from: {
                  avatar: "",
                  id: "op",
                  name: "",
                  photo: ""
                },
                message: [item.text],
                message2: [],
                timeStamp: moment(item.time_created).toISOString(),
                generic: {},
                parsedMessage: "",
                parsedButtons: [],
                shouldDisplayButtons: false,
                index: -1,
                loading: false
              }

            })



            for (let output of msgAr3) {

              //Publish answer from op to bus and indirectly to parent/messages
              this.messageBus.publishMessageToBus(output)
              Logger.info(`LV:HTTP:API operator response published on the bus: ${JSON.stringify(output)}`)
            }
          }
        }

      }
    } catch (err) {
      Logger.error(`LV:ERR readMessagesOnActiveChat2: ${JSON.stringify(err)}`)

      //TESTING
      // await this.sendMessageReq(`question n: ${t}`)
    }
  }

  publishErrorStatus(text: string, status: ChatMachineEventEnum): any {
    let output: IMessage = {
      from: {
        avatar: "",
        id: "op",
        name: "",
        photo: ""
      },
      message: [text],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: -1,
      loading: false
    }

    this.messageBus.publishMessageToBus(output)
    Logger.info(`LV:HTTP:API operator ERROR message published on the bus: ${JSON.stringify(output)}`)

    this.messageBus.publishMachineEventToBus(status)
    Logger.info(`LV:HTTP:API operator ERROR status published on the bus: ${JSON.stringify(status)}`)

  }

  /**
   * HTTP/axios api volani na Daktelu
   * @param message 
   */
  public async sendMessageReq(message: string) {

    try {
      if (this.fsmState === ChatMachineStatesEnum.opActive) {
        this.txStartTimestamp = moment().toISOString()
        let url = `${this.serverUrl}${this.contextUrl}sendMessage/${this.activeChatName}.json?accessToken=${this.token}&_uuid=${uuid.v4()}`
        let messageObj = {

          "type": "PUBLIC",
          "text": message,
          "direction": "IN"
        }
        let payload = messageObj
        Logger.info(`LV:Running send message req. with: ${url}, payload: ${JSON.stringify(payload)}`)



        let res = await this.axiosClient.post(url, payload)
        this.txEndTimestamp = moment().toISOString()

        Logger.info(`LV:HTTP:API Chat send message response with name: ${JSON.stringify(res)}`)
        return res
      }

    } catch (err) {
      Logger.error(`LV:ERR sendMessageReq: ${JSON.stringify(err)}`)
      if (err.response && err.response.status) {

        if (err.response.status == 400) {

          this.publishErrorStatus(this.LV_CHAT_NOT_ACTIVE, ChatMachineEventEnum.OP_UNEXPECTED_ERR)

        } else {

          this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_UNEXPECTED_ERR)

        }

        Logger.error(err.response.data);
        Logger.error(err.response.status);
        Logger.error(err.response.headers);
      } else if (err.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        Logger.error(err.request);
      } else {
        // Something happened in setting up the request and triggered an Error
        Logger.error(`Error: ${JSON.stringify(err.message)}`)
      }
      Logger.error(err);

    }

  }

  /**
   * Jedina funkce ktera se opakuje a hlida stav odpovedi od operatora
   * 
   * prvni response:
   * {"error":[],"result":{"hash":"NWQxNjJiZWZmOGIyYzMyNWJhODdlNDBiYzJjYTQwNmEtOTEx",
   * "name":"web_5ff5fb00bf3e0205578458","inputs":{"title":"","email":"","phone":"",
   * "customFields":[]},"allowInput":true,"userIsTyping":false,"suggestedAnswers":[],"disconnection":"",
   * "answered":false,
   * "messages":[{"name":"messages_5ff5fb00e3fbe906320647","type":"PUBLIC","direction":"",
   * "time_created":"2021-01-06T18:01:36+00:00","text":"Čekejte na spojení s operátorem.","user":null,"attachments":[]}],
   * "users":[],
   * "webRTC":{"room":null}},"_time":"2021-01-06 19:01:42"}
   * 
   * ZPRAVA PRI PRIPOJENI OPERATORA:
   * {"error":[],"result":{"hash":"NWQxNjJiZWZmOGIyYzMyNWJhODdlNDBiYzJjYTQwNmEtOTEy","name":"web_5ff5fb00bf3e0205578458",
   * "inputs":{"title":"","email":"","phone":"","customFields":[]},"allowInput":true,"userIsTyping":false,"suggestedAnswers":[],"disconnection":"",
   * "answered":true,
   * "messages":[{"name":"messages_5ff5fb14309e2418029133","type":"PUBLIC","direction":"",
   * "time_created":"2021-01-06T18:01:56+00:00","text":"UNTX_DEVEL se připojil/a k chatu","user":null,"attachments":[]}],
   * "users":[{"title":"UNTX_DEVEL","icon":false}],
   * "webRTC":{"room":null}},"_time":"2021-01-06 19:01:57"}
   * 
   * v pripade ukonceni OP je tam attribut DISCONNECTION:USER
   * 
   * 
   * @param name 
   * @param hash 
   */
  public async readMessageReq(): Promise<any> {
    try {
      this.txStartTimestamp = moment().toISOString()
      let url: string
      let isChange: boolean = false

      if (this.activeChatHash && this.activeChatHash.length > 0) {
        url = `${this.serverUrl}${this.contextUrl}webPullData/${this.activeChatName}.json?accessToken=${this.token}&hash=${this.activeChatHash}&_uuid=${uuid.v4()}`
      } else {
        url = `${this.serverUrl}${this.contextUrl}webPullData/${this.activeChatName}.json?accessToken=${this.token}&_uuid=${uuid.v4()}`
      }

      //   Logger.info(`LV:HTTP:API Running read message req. with: ${url}`)



      let res = await this.axiosClient.get(url)
      this.txEndTimestamp = moment().toISOString()
      let data = this.checkAndTransformResponse(res)
      if (data && data.result && typeof data.result === 'object' && data.error.length == 0) {
        /*
        //console.log("DEBUG readMessageReq====================================")
        Logger.info(`${JSON.stringify(data)}`)
        Logger.info('-'.repeat(50))
        Logger.info(data.result.answered)
        Logger.info('-'.repeat(50))
        Logger.info(`${JSON.stringify(data.result.users)}`)
        //console.log("DEBUG readMessageReq====================================")
        */

        this.activeChatName = data.result.name

        // Logger.info(`LV:HTTP:API Read op answers with result: ${JSON.stringify(data.result.messages)}. CHANGED: ${isChange}, ANSWERED (OP available): ${data.result.answered}`)

        return data.result

      } else {
        // SPATNA ODPOVED data.error pole neco obsahuje
        Logger.error(`LV:ERR readMessageReq: ${JSON.stringify(data.error)}`)
        return null
      }
    } catch (err) {
      if (err && err.message && err.message.indexof(`timeout of ${this.axiosTimeout}ms exceeded`) > -1) {
        Logger.info(`LV:HTTP:API ReadMessageReq: No response from operator before axios timeout`)

      } else {
        Logger.error(`LV:ERR readMessageReq: ${JSON.stringify(err)}`)
      }

      // this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_UNEXPECTED_ERR)

      return null
    }
  }

  public async checkChatStatusReq(shouldUploadReportSLA: boolean): Promise<ChatAvailabilityStateEnum> {
    try {



      this.txStartTimestamp = moment().toISOString()

      let url = `${this.serverUrl}${this.contextUrl}settings.json?accessToken=${this.token}&_uuid=${uuid.v4()}`

      Logger.info(`LV:HTTP:API Running initialcheck system status req. with: ${url}`)

      let res = await this.axiosClient.get(url)
      this.txEndTimestamp = moment().toISOString()

      let data = this.checkAndTransformResponse(res)



      // console.log(`LV:HTTP:API check system status with result: ${JSON.stringify(data.result.state)}`)

      if (data.result.state == ChatAvailabilityStateEnum.ONLINE) {
        this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_ONLINE)
        if (shouldUploadReportSLA) {
          this.createReportForLV(QueueAnswerEnumSLA.free)
          this.uploadReportForLV()
        }

        //TESTING ONLY
        //this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_BUSY)

      } else if (data.result.state == ChatAvailabilityStateEnum.BUSY) {
        this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_BUSY)
        if (shouldUploadReportSLA) {
          this.createReportForLV(QueueAnswerEnumSLA.busy)
          this.uploadReportForLV()
        }

      } else if (data.result.state == ChatAvailabilityStateEnum.OFFLINE) {
        this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_OFFLINE)
        if (this.slaCheckCounter == 0) {
          this.createReportForLV(QueueAnswerEnumSLA.busy)
          this.uploadReportForLV()
          this.slaCheckCounter += 1
        }
      }





      return data.result.state
      //TESTING ONLY
      //return ChatAvailabilityStateEnum.BUSY




    } catch (err) {
      Logger.error(`LV:ERR checkChatStatusReq: ${JSON.stringify(err)}`)
      this.messageBus.publishMachineEventToBus(ChatMachineEventEnum.OP_OFFLINE)
      if (this.fsmState == ChatMachineStatesEnum.botActiveAndWaitingToStartOfferOp) {
        if (this.slaCheckCounter == 0) {
          this.createReportForLV(QueueAnswerEnumSLA.busy)
          this.uploadReportForLV()
          this.slaCheckCounter += 1
        }
      }


    }
  }


  public async endChatReq(isForced?: boolean) {
    try {
      if (this.fsmState != ChatMachineStatesEnum.opEnded || isForced) {
        if (this.activeChatName && this.activeChatName.length > 0) {
          this.txStartTimestamp = moment().toISOString()

          let url = `${this.serverUrl}${this.contextUrl}updateWebChat/${this.activeChatName}.json?accessToken=${this.token}&disconnection=CLIENT&_uuid=${uuid.v4()}`

          Logger.info(`LV:HTTP:API Running end chat req. with: ${url}`)

          let res = await this.axiosClient.get(url)
          this.txEndTimestamp = moment().toISOString()
          let data = this.checkAndTransformResponse(res)
          Logger.info(`LV:HTTP:API end chat with result: ${JSON.stringify(data)}`)
          if (data.result && Array.isArray(data.error) && data.error.length == 0) {
            //Nic se nedeje - pro vsechny situace menim na notactive

          } else {
            Logger.error(`LV:ERR endChatReq: ${JSON.stringify(data.err)}`)
          }


          //Unsubscribe a zrusit odber polling read msg. volani
          this.newChatWaitForOperatorSubscription.unsubscribe()
          this.existingChatWaitForOperatorSubscription.unsubscribe()
        } else {
          Logger.warn('No active chat to end')

        }
      }
    } catch (err) {
      Logger.error(`LV:ERR endChatReq: ${JSON.stringify(err)}`)

      /*
        loguji v metode,
        TBD: how to handle
      */

    }
  }

  /**
   * PUT https://conectart-csu.daktela.com/external/web/api/updateWebchat/[NAME].json?accessToken=[QUEUE_ACCESS_TOKEN]
{"note": "", "score": 6}

Score je hodnota do 10. Note je nepovinné.
   */

  public async sendChatEvaluationReq(score: number): Promise<void> {
    try {
      this.txStartTimestamp = moment().toISOString()
      if (this.activeChatName && this.activeChatName.length > 0) {
        let payload = { note: "", score: score }

        let url = `${this.serverUrl}${this.contextUrl}updateWebChat/${this.activeChatName}.json?accessToken=${this.token}&_uuid=${uuid.v4()}`

        Logger.info(`LV:HTTP:API Running chat evaluation req. with: ${url}, payload: ${JSON.stringify(payload)}`)

        let res = await this.axiosClient.post(url, payload)

        this.txEndTimestamp = moment().toISOString()

        Logger.info(`LV:HTTP:API chat evaluation result: ${JSON.stringify(res)}`)

      } else {
        Logger.warn('No active chat to send evalution')
      }

    } catch (err) {
      Logger.error(`LV:HTTP:API:ERR sendChatEvaluationReq: ${JSON.stringify(err)}`)
      if (err.response && err.response.status) {

        if (err.response.status == 400) {
          this.publishErrorStatus(this.LV_CHAT_NOT_ACTIVE, ChatMachineEventEnum.OP_UNEXPECTED_ERR)
        }

        Logger.error(err.response.data);
        Logger.error(err.response.status);
        Logger.error(err.response.headers);
      } else if (err.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        Logger.error(err.request);
      } else {
        // Something happened in setting up the request and triggered an Error
        Logger.error(`Error: ${err.message}`);
      }
      Logger.error(err);
      /*
        loguji v metode,
        TBD: how to handle
      */

    }
  }

  /*
   pri stavu opAvailCheck
   a FSM funkci checkChatAvailabilityStatus
   (busy/online stav LV)
 */
  createReportForLV(queueAnswer: QueueAnswerEnumSLA) {
    if (this.currentRecordSLA == null) {

      this.currentRecordSLA = {
        date: moment().format('DD.MM.YYYY'),
        time: moment().format('HH:mm:ss'),
        sessionId: uuid.v4(),
        sourceId: this.channelSLA,
        queueAnswer: queueAnswer,
        queueRequestedTime: ''
      }
    } else {
      this.currentRecordSLA.date = null
      this.currentRecordSLA.date = moment(new Date()).format('DD.MM.YYYY')
      this.currentRecordSLA.time = null
      this.currentRecordSLA.time = moment(new Date()).format('HH:mm:ss')
      this.currentRecordSLA.queueAnswer = queueAnswer
      this.currentRecordSLA.queueRequestedTime = ''
      //Beze zmeny necham sourceId a sessionId
    }
  }

  udateReportForLV() {
    //  console.log(`LV:Client:SLA record to upload: ${JSON.stringify(this.currentRecordSLA)}`)
    //  console.log("DEGUG")
    if (this.currentRecordSLA && this.currentRecordSLA.sessionId) {
      this.currentRecordSLA.queueRequestedTime = null
      this.currentRecordSLA.queueRequestedTime = moment(new Date()).format('HH:mm:ss')
      if (moment(this.currentRecordSLA.queueRequestedTime, "HH:mm:ss").isSameOrBefore(moment(this.currentRecordSLA.time, "HH:mm:ss"))) {
        let tempMoment = moment(this.currentRecordSLA.queueRequestedTime, "HH:mm:ss").clone()
        this.currentRecordSLA.time = moment(tempMoment, "HH:mm:ss").subtract(2000 + (Math.floor(Math.random() * 10000)), 'ms').format('HH:mm:ss')
      }
      //   console.log("DEGUG")
      // this.currentRecordSLA.queueRequestedTime = moment(this.currentRecordSLA.queueRequestedTime,"HH:mm:ss").add(20000 + (Math.floor(Math.random() * 150000)),'ms').format('HH:mm:ss')


      Logger.info(`LV:Client:SLA record to upload: ${JSON.stringify(this.currentRecordSLA)}`)
    }
  }

  /*
    Pri createNewChat, doda se uuid, cas kliknuti na button a posle se na logger a lokalne reset pro dalsi kolo 
    -> take ve stavu opAvailCheck
  */
  async uploadReportForLV() {
    //Vynulovani


    try {
      Logger.info(`LV:HTTP:API:About to upload sla report: ${JSON.stringify(this.currentRecordSLA)}. Apikey: ${this.apikeySLA} to server: ${this.urlSLA}.`)
      let httpOptions = {
        headers: {
          'content-type': 'application/json',
          'opus-sec-token': this.apikeySLA

        }
      }
      let axiosResponse = await axios.post(`${this.urlSLA}/api/logger`, this.currentRecordSLA, httpOptions)
      if (axiosResponse.status && axiosResponse.status == 200) {
        Logger.info(`LV:HTTP:API SLA upload response OK with status: ${JSON.stringify(axiosResponse.status)}`)
      } else {
        Logger.error(`LV:HTTP:API unexpected error: ${axiosResponse.status} and ${axiosResponse.statusText}`)
      }
    } catch (error) {
      Logger.error(`LV:HTTP:API unexpected error: ${JSON.stringify(error)}`)
    }


  }

  /*
  Dodatecne 2/21 pro zjistovani stavu daktely, zda neni pretizena
  https://unitxstav.daktela.com/status.json
  pro vsechny prostredi shodne

  v pripade ze je FALSe se jiz pro browser neaktualizuje (az s novym reloadem) -> takze je mozne poslat okamzite
  */

  async saveSlaReportWhenGlobalStatusFalse() {


    this.currentRecordSLA = {
      date: moment().format('DD.MM.YYYY'),
      time: moment().format('HH:mm:ss'),
      sessionId: uuid.v4(),
      sourceId: this.channelSLA,
      queueAnswer: QueueAnswerEnumSLA.offline,
      queueRequestedTime: ''
    }

    this.uploadReportForLV()

  }

  async checkGlobalStatus() {
    try {
      let url = 'https://unitxstav.daktela.com/status.json'
      Logger.info(`LV:HTTP:API:About to check global availability status using server: ${url}.`)
      /// console.log('D0============================================ checkChatAvailabilityStatus')
      let axiosResponse = await axios.get(url, { timeout: 1000 })

      if (axiosResponse.status && axiosResponse.status == 200) {
        if (axiosResponse.data && axiosResponse.data.status) {
          //TEST only
          //axiosResponse.data.status = false
          if (axiosResponse.data.status) {
            Logger.info(`LV:HTTP:API Global availability status: GO`)
            return true
          } else {
            Logger.info(`LV:HTTP:API Global availability status: NO-GO`)
            this.saveSlaReportWhenGlobalStatusFalse()
            return false
          }
        } else {
          Logger.info(`LV:HTTP:API Global availability status: NO-GO`)
          return true
        }

      } else {
        Logger.error(`LV:HTTP:API Global availability  unexpected error: ${axiosResponse.status} and ${axiosResponse.statusText}`)
        Logger.info(`LV:HTTP:API Global availability status fail-back to: GO`)
        return true
      }

    } catch (error) {
      Logger.error(`LV:HTTP:API Global availability  unexpected error: ${JSON.stringify(error)}`)
      Logger.info(`LV:HTTP:API Global availability status fail-back to: GO`)
      return true
    }
  }

}
